var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"round-card",attrs:{"elevation":hover ? 12 : 6,"max-height":"350px"}},[_c('v-img',{attrs:{"src":_vm.card.img,"max-height":"350px"}},[_c('v-overlay',{attrs:{"absolute":""}},[_c('h2',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.card.title)+" ")])])],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }